import { ORDERS_EDIT_DISCOUNTS } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';

export function useCanEditDiscounts() {
  return useGetTags().includes(ORDERS_EDIT_DISCOUNTS);
}
